import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BetReceiptBody from './components/BetReceiptBody'
import BestOddsGuaranteed from '../../../../common/bestOddsGuaranteed';
import { multiplesInfo, forecastMultiples } from '../../../../common/utils/multiples';
import { formatDate } from '../../../../common/utils/formatDateTime';
import formatDecimalPrice from '../../../../common/utils/formatDecimalPrice';
import { calculateMoneyBreakdown } from '../../../../common/utils/calculateStake'
import './styles.scss';
import PRICE_TYPES from '../../../../common/utils/priceTypes';

export class BetReceipt extends Component {

    constructor() {
        super();
        this.getReceiptHeader = this.getReceiptHeader.bind(this);
        this.getBetReceiptBody = this.getBetReceiptBody.bind(this);
        this.getTricastForcastBody = this.getTricastForcastBody.bind(this);
        this.getSingleMultipleBody = this.getSingleMultipleBody.bind(this);
    }

    getReceiptHeader() {
        const {
            betType,
            isEachWay,
            numberLines,
        } = this.props

        const betTypeName = (betType.includes('accumulator'))
            ? 'accumulator'
            : betType
        const betTypeText = betTypeName === 'single'
            ? 'Single'
            : multiplesInfo[betTypeName].formTitle
        const header = `${betTypeText} ${isEachWay ? 'EW' : ''} (x${numberLines})`

        return (
            <div className="bs-betReceipt__header">
                {header}
            </div>
        )
    }

    getTricastForcastBody() {
        const {
            selections,
            betType,
        } = this.props;
        const {
            raceTime,
            courseName,
        } = selections[0];

        const HORSE_POSITIONS = ['1st', '2nd', '3rd'];
        const raceDate = formatDate(selections[0].raceDate);

        const raceData = (
            <div className="bs-betReceipt__row bs-betReceipt__details">
                <span> {`${raceTime} ${courseName}, ${raceDate}`} </span>
            </div>
        );

        const horses = selections.map((selection, index) => (
            <div
                key={`key-${selection.horseName}`}
                className="bs-betReceipt__row bs-betReceipt__horseName"
            >
                <span>
                    {(betType === 'straight-forecast' || betType === 'straight-tricast')
                        ? <span className="bs-betReceipt__horsePosition">
                            {HORSE_POSITIONS[index]}
                        </span>
                        : null
                    }
                    {selection.horseName}
                </span>
            </div>
        ));

        return (
            <div className="bs-betReceipt__body">
                {raceData}
                {horses}
            </div>
        )
    }

    getSingleMultipleBody() {
        const {
            selections,
            isEachWay,
            useDecimalOdds,
        } = this.props

        return selections.map((selection) => {
            const {
                horseName,
                priceType,
                raceTime,
                courseName,
                raceDate,
                eachWayFraction,
                eachWayPlaces,
                decimalPrice,
                fractionalPrice,
            } = selection

            const formattedDate = formatDate(raceDate);
            const price = useDecimalOdds ? `${formatDecimalPrice(decimalPrice)}` : fractionalPrice;

            return (
                <BetReceiptBody
                    key={`key-${horseName}`}
                    horseName={horseName}
                    priceType={priceType}
                    price={price}
                    raceTime={raceTime}
                    courseName={courseName}
                    raceDate={formattedDate}
                    isEachWay={isEachWay}
                    eachWayFraction={eachWayFraction}
                    eachWayPlaces={eachWayPlaces}
                />
            )
        })
    }

    getBetReceiptBody() {
        const {
            selections,
            betType,
        } = this.props;
        const isTricastForecast = betType && forecastMultiples.indexOf(betType) > -1;
        const body = isTricastForecast
            ? this.getTricastForcastBody()
            : this.getSingleMultipleBody();

        const bogBets = selections.filter(
            selection =>
                selection.isBog === 'Y'
                && selection.priceType !== PRICE_TYPES.SP
                && this.isBoGAvailable(selection, betType),
        );

        const bog = (
            bogBets.length !== selections.length
            || isTricastForecast
        )
            ? null
            : (
                <div className="bs-betReceipt__row bs-betReceipt__bog">
                    <BestOddsGuaranteed visible />
                </div>
            )

        return (
            <div>
                {body}
                {bog}
            </div>
        );
    }

    // eslint-disable-next-line class-methods-use-this
    isBoGAvailable(selection, betType) {
        if (!betType) {
            return false;
        }

        if (betType.toLowerCase() === 'single') {
            return true;
        }

        if (!selection) {
            return false
        }

        if (!selection.feed) {
            return false;
        }

        const noBoG = ['betfair'];

        return betType.toLowerCase() !== 'single' && !noBoG.includes(selection.feed.toLowerCase());
    }

    renderUnitStake() {
        const {
            currencySign,
            isEachWay,
            stakePerLine,
            numberLines,
        } = this.props;

        if (isEachWay || numberLines > 1) {
            const stakePerLineText = `${currencySign}${stakePerLine.toFixed(2)}`

            return (
                <div className="bs-betReceipt__row bs-betReceipt__unitStake">
                    <span>
                        {`Unit Stake per line ${stakePerLineText}`}
                    </span>
                </div>
            )
        }

        return null;
    }

    renderMoneyBreakdown() {
        const {
            selections,
            currencySign,
            freeBet,
        } = this.props

        const bet = selections[0]
        const stake = parseFloat(bet.stake, 10)

        const {
            userStake,
            freeStake,
        } = calculateMoneyBreakdown(stake, bet, freeBet.amount)

        const userStakeText = `${currencySign}${userStake.toFixed(2)}`
        const freeStakeText = `${currencySign}${freeStake.toFixed(2)}`

        return (
            <div className="bs-betReceipt__moneyBreakdown">
                <div className="bs-betReceipt__row">
                    <span className="bs-betReceipt__moneyBreakdownLabel">Your Money</span>
                    <span className="bs-betReceipt__moneyBreakdownValue">{userStakeText}</span>
                </div>
                <div className="bs-betReceipt__row">
                    <span className="bs-betReceipt__moneyBreakdownLabel">Free Bet Used</span>
                    <span className="bs-betReceipt__moneyBreakdownValue">{freeStakeText}</span>
                </div>
            </div>
        )
    }

    render() {
        const {
            receiptId,
            totalStake,
            returns,
            currencySign,
            freeBet,
        } = this.props

        const moneyBreakdown = freeBet ? this.renderMoneyBreakdown() : null
        const formattedReturns = returns === 'N/A'
            ? returns
            : `${currencySign}${parseFloat(returns, 10)
                .toFixed(2)}`

        return (
            <div className="bs-betReceipt">

                {this.getReceiptHeader()}
                {this.getBetReceiptBody()}

                <div className="bs-betReceipt__footer">
                    {this.renderUnitStake()}
                    {moneyBreakdown}
                    <div className="bs-betReceipt__row bs-betReceipt__totalStake">
                        <span>
                            Total Stake for this bet
                        </span>
                        <span>
                            {`${currencySign}${totalStake.toFixed(2)}`}
                        </span>
                    </div>
                    <div className="bs-betReceipt__row bs-betReceipt__estReturn">
                        <span>
                            Est. Returns for this bet
                        </span>
                        <span>
                            {formattedReturns}
                        </span>
                    </div>
                    <div className="bs-betReceipt__row">
                        <span>
                            {`Receipt No: ${receiptId}`}
                        </span>
                    </div>
                </div>
            </div>
        )
    }
}

BetReceipt.defaultProps = {
    isEachWay: false,
    returns: '',
    freeBet: null,
};

BetReceipt.propTypes = {
    receiptId: PropTypes.string.isRequired,
    betType: PropTypes.string.isRequired,
    currencySign: PropTypes.string.isRequired,
    totalStake: PropTypes.number.isRequired,
    returns: PropTypes.string,
    isEachWay: PropTypes.bool,

    selections: PropTypes.arrayOf(
        PropTypes.shape({
            horseName: PropTypes.string.isRequired,
            courseName: PropTypes.string.isRequired,
            raceTime: PropTypes.string.isRequired,
            raceDate: PropTypes.string.isRequired,
            eachWayPlaces: PropTypes.string,
            eachWayFraction: PropTypes.string,
            isBog: PropTypes.string,
            fractionalPrice: PropTypes.string.isRequired,
            decimalPrice: PropTypes.number,
            priceType: PropTypes.string.isRequired,
        }),
    ).isRequired,
    useDecimalOdds: PropTypes.bool.isRequired,
    stakePerLine: PropTypes.number.isRequired,
    numberLines: PropTypes.number.isRequired,
    freeBet: PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.string,
        amount: PropTypes.number.isRequired,
        minStake: PropTypes.number,
        maxStake: PropTypes.number,
    }),
};

export default BetReceipt;



// WEBPACK FOOTER //
// /src/js/drawer/components/BetReceiptPage/components/BetReceipt.jsx